import { GroupedTableColumn } from "./GroupedTable";
import { GroupedTableCell } from "./GroupedTableCell";

type Props = {
  columns: GroupedTableColumn[];
  item: any;
  onClick: () => void;
  disableSelectItems?: boolean;
};

const GroupedTableColumns = ({
  columns,
  item,
  onClick,
  disableSelectItems,
}: Props) => (
  <>
    {columns.map((column, index) => (
      <GroupedTableCell
        key={column.fieldName}
        column={column}
        value={!!item[column.fieldName] ? item[column.fieldName] : ""}
        flairComponent={column.flairComponent ? item["flairComponent"] : null}
        onClick={onClick}
        index={index}
        disableSelectItems={disableSelectItems}
      />
    ))}
  </>
);

export default GroupedTableColumns;
